export default "__VITE_ASSET__BC31dHc6__"